//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from "@/utils/validations.js";
import { noValidation } from "@/utils/validations.js";
import BackendServices from "@/services/backend-services.js";

export default {
  name: "AutomaticUploadsForm",
  components: {},
  props: ["value"],
  mounted: async function () {
    let response = await BackendServices.getSchedulingPublishers();
    this.publisherList = response.data;

    let availableCredentialsResponse = await BackendServices.getCredentialsList();
    this.availableCredentials = availableCredentialsResponse.data;

  },
  data: () => ({
    newUploadClicked: 0,
    validForm: false,
    publisherList: null,
    periodicityList: null,
    date: null,
    availableCredentials: null,
  }),
  computed: {},
  methods: {
    required,
    noValidation,
    validateData: function () {
      this.$refs.form.validate().then((success) => {
        if (success) {
          this.validForm = true;
          this.$emit("form-valid", this.validForm);
        } else {
          this.validForm = false;
          this.$emit("form-invalid", this.validForm);
        }
      });
    },
    updateData: function () {
      this.$emit("value", this.value);
    },
    validateEmail(value) {
      var regex = /^([\w-.]+@([\w-]+\.)+[\w-]{2,4})?$/;
      var result = value.replace(/\s/g, "").split(/,|;/);
      for (var i = 0; i < result.length; i++) {
        if (!regex.test(result[i])) {
          return false;
        }
      }
      return true;
      // const emailFormat = /^(?=[a-zA-Z0-9@._%+-]{6,254}$)[a-zA-Z0-9._%+-]{1,64}@(?:[a-zA-Z0-9-]{1,63}\.){1,8}[a-zA-Z]{2,63}$/;
      // return emailFormat.test(value);
    },
  },
  watch: {
    value: {
      deep: true,
      handler: function () { },
    },
  },
};
